/**
 * TeamSystem Impact - Year Management Page
 *
 * Pagina "Gestione Anno" sotto Impostazioni. Riusa il pannello completo di
 * configurazione anno (DMASettings) ancorandolo all'anno di lavoro corrente.
 * Include la gestione del ciclo di vita degli anni (archivia / elimina).
 */

import { useWorkingYear } from '../../store/workingYearStore';
import { DMASettings } from '../dma/components/DMASettings';

export function YearManagementPage() {
  const { year } = useWorkingYear();
  return <DMASettings assessmentYear={year} />;
}

export default YearManagementPage;
